"use client";

import { useCallback, useEffect, useState } from "react";
import SectionGridList from "../SectionGridList";
import { fetchUser } from "@/app/funcs/api";
import AdminChallengeDeliverablesPreview from "./AdminChallengeDeliverablesPreview";
import { isLegacyChallengeListItemEnded } from "./challengeDeadline";

function isChallengeStaffRole(roles) {
  if (!Array.isArray(roles)) return false;
  return roles.includes("administrator") || roles.includes("commadmin");
}

export default function ChallengesPage() {
  const [isStaff, setIsStaff] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const u = await fetchUser();
        if (!cancelled) setIsStaff(isChallengeStaffRole(u?.roles));
      } catch {
        if (!cancelled) setIsStaff(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const cardFooter = useCallback(
    (item) => (isStaff ? <AdminChallengeDeliverablesPreview challengeId={item.id} /> : null),
    [isStaff]
  );

  return (
    <SectionGridList
      postType="challenge"
      pageTitle="التحديات"
      description="استكشف أحدث التحديات وشارك أعمالك وتابع أفكار وتجارب مجتمع المصممين."
      hrefBase="challenges"
      searchPlaceholder="ابحث عن تحدٍ..."
      emptyMessage="لا يوجد تحديات متاحة حالياً."
      fallbackIcon="bi-lock"
      imageMaxHeight="220px"
      imageFit="cover"
      blockItem={isLegacyChallengeListItemEnded}
      blockedItemMessage="انتهى هذا التحدي ولم يعد متاحًا للعرض."
      cardFooter={isStaff ? cardFooter : null}
    />
  );
}
